export default "__VITE_ASSET__D0L13uPK__"